import { render, staticRenderFns } from "./biostatistics.vue?vue&type=template&id=7bae272e&scoped=true"
import script from "./biostatistics.vue?vue&type=script&lang=js"
export * from "./biostatistics.vue?vue&type=script&lang=js"
import style0 from "./biostatistics.vue?vue&type=style&index=0&id=7bae272e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae272e",
  null
  
)

export default component.exports